import { useIntl } from 'react-intl';
import { BookingFeature } from 'app/data/types/booking';
import { amenityIcon } from 'app/shared/consts/booking';

interface BookingAmenitiesProps {
  features: BookingFeature[];
}

/**
 * Room amenities list. Each feature's `default_type` maps to a lucide icon (fallback: a generic check).
 * The feature `name` is admin-authored free text (e.g. "Men's Room", may contain braces) — render it
 * verbatim; NEVER as an ICU message id (that would parse-throw / mangle).
 */
export const BookingAmenities = ({ features }: BookingAmenitiesProps): JSX.Element | null => {
  const intl = useIntl();

  if (!features.length) return null;

  return (
    <div data-testid="booking-amenities">
      <h2 className="text-lg font-semibold text-foreground">
        {intl.formatMessage({ id: 'booking.detail.amenities' })}
      </h2>
      <ul className="mt-3 flex flex-col gap-3">
        {features.map((feature) => {
          const Icon = amenityIcon(feature);
          return (
            <li key={`${feature.default_type ?? ''}:${feature.name}`} className="flex items-center gap-3">
              <Icon size={20} strokeWidth={1.75} className="shrink-0 text-system-grey-dark" aria-hidden />
              <span className="text-[15px] text-foreground">{feature.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
